<div class="modal fade" id="editRoomModal" tabindex="-1" aria-labelledby="editModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5 text-white" id="editModalLabel">Edit Room</h1>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"
                    aria-label="Close"></button>
            </div>
            <div class="modal-body text-white">

                <ul class="nav nav-tabs mb-3 border-0" id="editRoomTabs" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button class="nav-link active text-white" id="details-tab" data-bs-toggle="tab"
                            data-bs-target="#details" type="button" role="tab" aria-controls="details"
                            aria-selected="true">Details</button>
                    </li>
                    @if(!arena()?.parentGuid) {
                    <li class="nav-item" role="presentation">
                        <button class="nav-link text-white" id="images-tab" data-bs-toggle="tab"
                            data-bs-target="#images" type="button" role="tab" aria-controls="images"
                            aria-selected="false">Images</button>
                    </li>
                    }
                    @if(!arena()?.parentGuid) {
                    <li class="nav-item" role="presentation">
                        <button class="nav-link text-white" id="members-tab" data-bs-toggle="tab"
                            data-bs-target="#members" type="button" role="tab" aria-controls="members"
                            aria-selected="false">Members</button>
                    </li>
                    }
                </ul>

                <div class="tab-content" id="editRoomTabsContent">
                    <!-- DETAILS TAB -->
                    <div class="tab-pane fade show active" id="details" role="tabpanel" aria-labelledby="details-tab">
                        <form [formGroup]="arenaForm">
                            <div class="row">
                                <div class="col-md-6 col-sm-12"></div>
                                <div class="col-md-6 col-sm-12"></div>
                            </div>
                            <div class="form-floating mb-3">
                                <input formControlName="title" class="form-control" placeholder="Arena Title" />
                                <label>Title</label>
                            </div>

                            <div class="form-floating mb-3">
                                <textarea formControlName="description" style="height: 100px;" class="form-control"
                                    placeholder="Arena Description"></textarea>
                                <label>Description</label>
                            </div>

                            <div class="form-floating mb-3">
                                <input type="password" formControlName="password" class="form-control"
                                    placeholder="Password" />
                                <label>Password</label>
                            </div>

                            <div class="form-check form-check-inline">
                                <input type="checkbox" class="form-check-input" formControlName="isPublic" id="editIsPublicCheck" />
                                <label class="form-check-label cursor-pointer" for="editIsPublicCheck">Public</label>
                            </div>

                            <div class="form-check form-check-inline">
                                <input type="checkbox" class="form-check-input" formControlName="isStatic" id="editIsStaticCheck" />
                                <label class="form-check-label cursor-pointer" for="editIsStaticCheck">Static</label>
                            </div>

                            <div class="form-check form-check-inline">
                                <input type="checkbox" class="form-check-input" formControlName="hasVoice" />
                                <label class="form-check-label">Voice</label>
                            </div>

                            <div class="form-check form-check-inline">
                                <input type="checkbox" class="form-check-input" formControlName="hasVideo" />
                                <label class="form-check-label">Video</label>
                            </div>

                            <div class="form-check form-check-inline mb-3">
                                <input type="checkbox" class="form-check-input" formControlName="hasImages" />
                                <label class="form-check-label">Images</label>
                            </div>

                            <div class="form-floating mb-3">
                                <input type="text" formControlName="motd" class="form-control"
                                    placeholder="Message of the Day" />
                                <label>Message of the Day</label>
                            </div>

                            <div class="form-floating mb-3">
                                <input type="text" formControlName="url" class="form-control"
                                    placeholder="Optional URL" />
                                <label>Optional URL</label>
                            </div>

                             <div class="dropdown">
                                <button class="btn btn-xl btn-outline-primary dropdown-toggle" type="button"
                                    id="iconDropdownButton"
                                    [class.is-invalid-icon]="arenaForm.get('avatarURL')?.invalid && arenaForm.get('avatarURL')?.touched"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                    @if(selectedIcon()) {
                                    <img src="{{arenaSignal().avatarURL}}" class="me-2" width="64" height="64"
                                        alt="Selected Icon" />
                                    }@else if(arenaSignal()?.avatarURL){
                                    <img src="{{arenaSignal().avatarURL}}" class="me-2" width="64" height="64"
                                        alt="Current Icon" />
                                    }@else{
                                    <img src="/images/logo_1_2.png" class="me-2" width="64" height="64"
                                        alt="Default Icon" />
                                    }
                                    {{ selectedIcon() ? 'Change Icon' : 'Select Icon' }}
                                </button>

                                @if(arenaForm.get('avatarURL')?.invalid && arenaForm.get('avatarURL')?.touched) {
                                <div class="small text-danger mt-2">
                                    Please select a room icon.
                                </div>
                                }

                                <ul class="dropdown-menu bg-dark text-white p-2" aria-labelledby="iconDropdownButton"
                                    style="max-height: 300px; overflow-y: auto;">
                                    @for(icon of arenaIcons(); track $index) {
                                    <li class="text-white">
                                        <a class="dropdown-item d-flex align-items-center" (click)="selectIcon(icon)"
                                            style="cursor: pointer;">
                                            <img src="https://usercontent.h5arena.com/arenas/{{icon.guid}}{{icon.fileExtension}}"
                                                width="64" height="64" class="me-2" />
                                            {{icon.title ? icon.title: "No Title"}}
                                        </a>
                                    </li>
                                    }
                                </ul>
                            </div>
                        </form>
                    </div>

                    <!-- IMAGES TAB -->
                    @if(!arena()?.parentGuid) {
                    <div class="tab-pane fade mt-4" id="images" role="tabpanel" aria-labelledby="images-tab">
                        <div class="drop-zone mb-4 p-5 border border-2 border-secondary rounded"
                            [class.border-primary]="isDragging()" [class.bg-dark]="!isDragging()"
                            [class.bg-secondary]="isDragging()"
                            style="border-style: dashed !important; cursor: pointer; transition: all 0.2s ease;"
                            (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)"
                            (click)="fileInput.click()">
                            <input type="file" #fileInput class="d-none"
                                accept="image/png, image/jpeg, image/gif, image/webp, image/bmp"
                                (change)="onFileSelected($event)" />

                            @if(isUploading()) {
                            <div class="uploading-state text-center">
                                <div class="spinner-border text-primary mb-2" role="status">
                                    <span class="visually-hidden">Uploading...</span>
                                </div>
                                <p class="mb-2 text-white">Uploading image...</p>
                                <div class="progress" style="height: 10px;">
                                    <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary"
                                        role="progressbar" [style.width.%]="uploadProgress()"
                                        [attr.aria-valuenow]="uploadProgress()" aria-valuemin="0" aria-valuemax="100">
                                    </div>
                                </div>
                            </div>
                            } @else {
                            <div class="idle-state text-center text-muted">
                                <i class="bi bi-cloud-arrow-up fs-1 mb-2"></i>
                                <h5 class="text-white">Drag & Drop your image here</h5>
                                <p class="mb-0">or click to browse</p>
                                <small>Supports BMP, PNG, JPG, GIF, WEBP</small>
                            </div>
                            }
                        </div>

                        <div class="row row-cols-2 row-cols-md-4 g-3 mt-3">
                            @for(icon of arenaIcons(); track $index) {
                            <div class="col">
                                <div
                                    class="card bg-dark border-secondary h-100 position-relative image-card overflow-hidden">
                                    <button type="button"
                                        class="btn btn-sm btn-danger position-absolute top-0 end-0 m-1"
                                        style="z-index: 10;" (click)="deleteImage(icon.guid)" title="Delete Image">
                                        <i class="bi bi-trash-fill"></i>
                                    </button>
                                    <img src="https://usercontent.h5arena.com/arenas/{{icon.guid}}{{icon.fileExtension}}"
                                        class="card-img-top p-2" style="object-fit: contain; aspect-ratio: 1;"
                                        alt="Arena Icon">
                                    <div class="card-body p-2 text-center border-top border-secondary">
                                        <small class="text-truncate text-white-block mb-2">{{icon.title || 'No
                                            Title'}}</small>
                                        <button type="button" class="btn btn-outline-primary btn-sm w-100"
                                            (click)="selectIcon(icon)">Set as Icon</button>
                                    </div>
                                </div>
                            </div>
                            }
                            @if(arenaIcons().length === 0) {
                            <div class="col-12">
                                <p class="text-muted text-center">No images uploaded yet.</p>
                            </div>
                            }
                        </div>
                    </div>
                    }

                    <!-- MEMBERS TAB -->
                    @if(!arena()?.parentGuid) {
                    <div class="tab-pane fade mt-4" id="members" role="tabpanel" aria-labelledby="members-tab">

                        <div class="row mb-4 align-items-center">
                            <div class="col-md-6 mb-2 mb-md-0">
                                <div class="form-floating">
                                    <input type="text" class="form-control" placeholder="Username to add"
                                        [value]="newMemberUsername()"
                                        (input)="newMemberUsername.set($any($event.target).value)">
                                    <label>USERNAME TO ADD</label>
                                </div>
                            </div>
                            <div class="col-md-4 mb-2 mb-md-0">
                                <div class="form-floating">
                                    <select class="form-select" [value]="newMemberRole()"
                                        (change)="newMemberRole.set($any($event.target).value)">
                                        <option value="member">Member</option>
                                        <option value="admin">Admin</option>
                                    </select>
                                    <label>ROLE</label>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <button type="button" class="btn btn-danger w-100" style="height: 3.5rem;"
                                    (click)="addNewMember()" [disabled]="!newMemberUsername()">
                                    <i class="bi bi-plus-lg fw-bold"></i> Add
                                </button>
                            </div>
                        </div>

                        <ul class="list-group list-group-flush border border-secondary rounded shadow-sm">
                            @for(member of members(); track member.userId) {
                            <li
                                class="list-group-item bg-dark text-white border-secondary d-flex justify-content-between align-items-center py-3">
                                <div>
                                    <span class="fw-bold fs-5">{{ member.userName }}</span>
                                </div>
                                <div class="d-flex align-items-center gap-2">
                                    <select class="form-select form-select-sm w-auto" [value]="member.role"
                                        (change)="setMemberRole(member, $any($event.target).value)"
                                        style="background-color: #1e1e1e; border-color: #4a4a52;">
                                        <option value="member">Member</option>
                                        <option value="admin">Admin</option>
                                    </select>
                                    <button type="button" class="btn btn-sm btn-outline-secondary text-danger border-0"
                                        (click)="removeMember(member.userId)" title="Remove Member">
                                        <i class="bi bi-trash-fill fs-5"></i>
                                    </button>
                                </div>
                            </li>
                            }
                            @if(members().length === 0) {
                            <li class="list-group-item bg-dark text-muted border-secondary text-center py-4">
                                No members added yet. Add a user above.
                            </li>
                            }
                        </ul>
                    </div>
                    }
                </div>

            </div>
            <div class="modal-footer p-0 border-0 gap-0">
                <button type="button" class="btn btn-dark w-50 m-0 rounded-0 rounded-bottom-start fw-bold"
                    style="height: 4rem;" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-danger w-50 m-0 rounded-0 rounded-bottom-end fw-bold"
                    style="height: 4rem;" (click)="update()">Save Changes</button>
            </div>
        </div>
    </div>
</div>